import { combineReducers } from 'redux'

import record from './record'
import uiFlags from './uiFlags'

export default combineReducers({
  uiFlags,
  record,
})
